export const getResizedImageUrl = ({url, width, height}) => {

    if(url==null) return

    const arrUrl = url.split('/')
    const fileName = arrUrl[arrUrl.length - 1]

    return `https://daw381fip1vm8.cloudfront.net/fit-in/${width}x${height}/${fileName}`
}